export default function Terms() {
    return (
        <div className="max-w-5xl mx-auto mt-8 px-4 space-y-8">
            <h1 className="text-4xl font-bold text-center">Terms of Service</h1>
            <p className="text-center">Effective Date: October 31, 2025</p>

            <ol className="list-decimal text-lg list-inside space-y-6">
                <li>
                    <h2 className="inline text-lg font-semibold">Acceptance of Terms</h2>
                    <p className="mt-1 text-md">
                        By using GiftLoop (“App”), you agree to these Terms of Service (“Terms”). If you do not agree, do not use the App.
                    </p>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Use of the App</h2>
                    <ul className="list-disc list-inside text-md ml-4 mt-2 space-y-1">
                        <li>You may use the App to create and manage gift registries.</li>
                        <li>You are responsible for providing accurate information in your account and registries.</li>
                        <li>You may not use the App for unlawful purposes or to infringe on the rights of others.</li>
                    </ul>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">User Accounts</h2>
                    <ul className="list-disc list-inside text-md ml-4 mt-2 space-y-1">
                        <li>You must create an account to use certain features of the App.</li>
                        <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
                        <li>You may not share your account credentials with others.</li>
                    </ul>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">User-Generated Content</h2>
                    <ul className="list-disc list-inside text-md ml-4 mt-2 space-y-1">
                        <li>You retain ownership of the content you create (gift lists, item notes, etc.).</li>
                        <li>By using the App, you grant us a license to use, store, and display your content to provide App functionality.</li>
                        <li>You are responsible for the content you post and must not post illegal, offensive, or infringing material.</li>
                    </ul>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Third-Party Services</h2>
                    <p className="mt-1 text-md">
                        The App may use third-party services such as Google Analytics and Firebase. Your use of these services is also governed by their respective terms and policies.
                    </p>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Limitation of Liability</h2>
                    <ul className="list-disc list-inside text-md ml-4 mt-2 space-y-1">
                        <li>The App is provided “as is.”</li>
                        <li>We are not liable for any indirect, incidental, or consequential damages arising from your use of the App.</li>
                        <li>We do not guarantee that your registries will be error-free or that gifts will be purchased or delivered.</li>
                    </ul>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Privacy</h2>
                    <p className="mt-1 text-md">
                        Use of the App is also governed by our <a href="/privacy" className="text-blue-600 underline">Privacy Policy</a>.
                    </p>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Termination</h2>
                    <p className="mt-1 text-md">
                        We may suspend or terminate your access to the App at our discretion, with or without notice, for violations of these Terms.
                    </p>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Changes to Terms</h2>
                    <p className="mt-1 text-md">
                        We may update these Terms from time to time. Continued use of the App after changes constitutes acceptance of the new Terms.
                    </p>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Governing Law</h2>
                    <p className="mt-1 text-md">
                        These Terms are governed by the laws of the State of Florida, U.S.A.
                    </p>
                </li>

                <li>
                    <h2 className="inline text-lg font-semibold">Contact Us</h2>
                    <p className="mt-1 text-md">
                        For questions regarding these Terms, contact us at <a href="mailto:giftloopapp@gmail.com" className="text-blue-600 underline">giftloopapp@gmail.com</a>.
                    </p>
                </li>
            </ol>
        </div>
    );
}
